/* eslint-disable promise/param-names */
import {
  BACKUPS_REQUEST,
  BACKUPS_SUCCESS,
  BACKUPS_REPLACE,
  BACKUPS_CREATE,
  BACKUPS_CREATE_JSON
} from '@/store/actions/backups';

import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/functions';
import 'firebase/storage';

import querystring from 'querystring-browser';
import moment from 'moment';

import Vue from 'vue';
import {sleep} from '@/utils/utils.js'

import {saveAs} from 'file-saver';

const storageBaseLink = process.env.VUE_APP_STORAGE_BASE_LINK

const state = { 
  backups: [],
  status: '',
  hasLoadedOnce: false,
};

const getters = {
  backups: state => state.backups ? state.backups : [],
  backupsLoading: state => state.status == 'loading'
};

const actions = {
  [BACKUPS_REQUEST]: ({commit}) => {
    if (state.hasLoadedOnce) {
      return;
    }

    return new Promise((resolve) => {
      commit(BACKUPS_REQUEST)

      firebase.firestore().collection('backups').orderBy('created')
        .onSnapshot(querySnapshot => {
          let backups = []

          querySnapshot.docChanges().forEach(change => {
            let backup = change.doc.data()
            backup.id = change.doc.id
            backup.created = new Date(backup.created.seconds * 1000)

            if (backup.ended !== undefined) {
              backup.ended = new Date(backup.ended.seconds * 1000)
            }

            backups.push(backup);
          })

          if (state.hasLoadedOnce == false) {
            commit(BACKUPS_SUCCESS, backups)
          } else {

            commit(BACKUPS_REPLACE, backups)
          }

          resolve();
        })
    })
  },

  [BACKUPS_CREATE]: ({commit}) => {
    const createBackup = firebase.functions().httpsCallable('createBackup');
    createBackup()
        .catch(err => {
          console.log(err)
        });
  },

  [BACKUPS_CREATE_JSON]: async ({commit}) => {
    commit(BACKUPS_REQUEST)

    const collections = [
      'authorOfTheDay',
      'authors',
      'books',
      'bookAccess',
      'categories',
      'lawyers',
      'meta',
      'pages',
      'props',
      'publishers',
      'stats',
    ];

    const backup = {};

    for (let x = 0; x < collections.length; x++) {
      await firebase.firestore().collection(collections[x]).get()
          .then(querySnapshot => {
            backup[collections[x]] = [];

            querySnapshot.forEach(doc => {
              backup[collections[x]].push(doc.data())
            })
          })
          .catch(err => console.log(err));
    };

    const fileName = moment().format('[backup_]YYYY_MM_DD_HH_mm_ss');
    const file = new File([JSON.stringify(backup)], fileName, {type: "application/json;charset=utf-8"});
    
    commit(BACKUPS_SUCCESS);
    saveAs(file);
  },
}

const mutations = {
  [BACKUPS_REQUEST]: (state) => {
    state.status = 'loading';
  },

  [BACKUPS_SUCCESS]: (state, backups) => {
    state.status = 'success'

    if (backups != undefined) {
      state.backups = backups;
      state.hasLoadedOnce = true;
    }
  },

  [BACKUPS_REPLACE]: (state, backups) => {
    backups.forEach(backup => {
      let rowIndex = state.backups.findIndex(elem => elem.id == backup.id)
      if (rowIndex != -1) {
        Vue.set(state.backups, rowIndex, backup)
      } else {
        state.backups.push(backup)
      }
    })
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
}
